// src/models/empresaModel.js

import pb from '../lib/pocketbase';

// Obtener una lista de empresas con paginación
export async function getEmpresas(page, perPage) {
  return await pb.collection('empresa').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false // Desactiva la auto-cancelación
  });
}

// Crear una nueva empresa
export async function createEmpresa(empresa) {
  return await pb.collection('empresa').create(empresa);
}

// Actualizar una empresa existente
export async function updateEmpresa(id, empresa) {
  return await pb.collection('empresa').update(id, empresa);
}

// Eliminar una empresa por su ID
export async function deleteEmpresa(id) {
  return await pb.collection('empresa').delete(id);
}
